import { takeEvery, put } from "redux-saga/effects";

import axios from "axios";

import { subjectApi } from "../../../utility/api/apiList";

import subjectType from "./subjectType";
import { successFetchedSubject } from "./subjectActions";

export function* startfetchingSubject(action) {
  const response = yield axios.get(subjectApi);
  const handle = yield put(successFetchedSubject(response.data));
}

export function* fetchSubject() {
  yield takeEvery(subjectType.START_FETCHING_SUBJECT, startfetchingSubject);
}
